import DatePickerModule from 'react-datepicker';

export const DatePicker = (DatePickerModule as any).default ?? DatePickerModule;
